import styled from 'styled-components';
import { userPanelElementStyles } from '../../../styles/sharedStyles';

export const StyledContentElement = styled.div`
    ${userPanelElementStyles};
`;
